import { useEffect, useState } from "react";
import PanicAlertTable from "./PanicAlertTable";
import { getFormattedDate } from "../utils/getDate";
import { useUser } from "../Contexts/UserContext";
const API_URL = process.env.REACT_APP_DOMAIN_API_URL;
const PanicPage = () => {
  const [defaultTableData, setDefaultTableData] = useState([]);
  const [isChecked, setIsChecked] = useState(false);
  const [showTicket, setShowTicket] = useState(false);
  const [ticketData, setTicketData] = useState({});
  const [checkbox, setCheckbox] = useState(1);
  const [remark, setRemark] = useState("");
  const date = getFormattedDate();
  const { user } = useUser();
  const onTicketHandleClick = async () => {
    if (remark === "") {
      alert("Please Add Remark Before marking it Handled");
      return;
    }
    const response = await fetch(
      `${API_URL}/facility/get-post-panic-reports/3/${user.CompCode}/${user.ClientId}/${remark}/Suraj/${ticketData.PanicCode}/${date}/2024-05-22`
    ).then((res) => res.json());
    if (response.success) {
      setShowTicket(false);
      fetchHandledTicket();
    } else {
      alert("Error");
    }
  };
  const handleDefaultTableData = (data) => {
    setIsChecked(false);
    setDefaultTableData(data);
  };
  const fetchHandledTicket = async () => {
    const response = await fetch(
      `${API_URL}/facility/get-post-panic-reports/2/${user.CompCode}/${user.ClientId}/Testing/Suraj/6/${date}/${date}`
    ).then((res) => res.json());
    console.log(response);
    if (response.success) {
      setDefaultTableData(response.data);
    } else {
      alert("Error");
    }
  };
  const fetchUnHandledTicket = async () => {
    console.log("fetching Unhandled Panics");
    const response = await fetch(
      `${API_URL}/facility/get-post-panic-reports/1/${user.CompCode}/${user.ClientId}/Testing/Suraj/6/${date}/${date}`
    ).then((res) => res.json());
    console.log(response);
    if (response.success) {
      setDefaultTableData(response.data);
    } else {
      alert("Error");
    }
  };
  const fetchPanic = async (val) => {
    const response = await fetch(
      `${API_URL}/facility/get-post-panic-reports/${val}/${user.CompCode}/${user.ClientId}/Testing/Suraj/6/${date}/${date}`
    ).then((res) => res.json());
    console.log(response);
    if (response.success) {
      setDefaultTableData(response.data);
    } else {
      alert("Error");
    }
  };
  const onCheckBoxChange = async (flag = true) => {
    if (!flag) {
      setIsChecked(false);
      return;
    }
    setShowTicket(false);
    setIsChecked(!isChecked);
    !isChecked ? fetchHandledTicket() : fetchUnHandledTicket();
    // setTableData(response);
    // handleSearch(searchTerm);
  };
  const handleCheckboxChange = (val) => {
    // 0 - > all 1-> open  2->closed 3->post
    if (val == 0) {
      fetchPanic(0); // open
    } else if (val == 1) {
      fetchPanic(1);
    } else {
      fetchPanic(2);
    }
    setCheckbox(val);
  };
  return (
    <>
      <div style={{ padding: "1rem 4rem" }}>
        {/* <div className="d-flex"> */}
        <PanicAlertTable
          handleDefaultTableData={handleDefaultTableData}
          defaultTableData={defaultTableData}
          handleCheckBoxChange={onCheckBoxChange}
          isChecked={isChecked}
          showTicket={showTicket}
          setShowTicket={setShowTicket}
          ticketData={ticketData}
          setTicketData={setTicketData}
          onTicketHandleClick={onTicketHandleClick}
          setRemark={setRemark}
          setCheckbox={handleCheckboxChange}
          checkbox={checkbox}
        />
        {/* </div> */}
      </div>
    </>
  );
};
export default PanicPage;
